module.exports = __webpack_public_path__ + "static/media/performance-clock.6285abc9.svg";